export default __webpack_public_path__ + "static/media/draw_cut_dash_line.a52f640d.svg";